import React, { Component, Fragment } from 'react';

import RoundEdit from '../../Sale/RoundSection/RoundEdit';
import { localizable } from '../../../components/Localization';

@localizable
class CounterofferStep2 extends Component {
  render() {
    var {
      store: { roundEditStore },
      t,
    } = this.props;
    return (
      <Fragment>
        <ul className="hint">
          <li>{t('Please define the next round.')}</li>
          <li>{t('Validity of offers set to the same value')}</li>
        </ul>

        <div className="control">
          <RoundEdit store={roundEditStore} allowedRounds={["counteroffer_bidding"]} />
        </div>
      </Fragment>
    );
  }
}

export default CounterofferStep2;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Counteroffer/Step2.jsx